import type {FeatureFlag, FeatureFlagKey} from '../types'

export const checkFeatureFlag = (featureFlags: FeatureFlag[], key: FeatureFlagKey): boolean => {
  if (!featureFlags || featureFlags.length === 0) {
    return false
  }

  const flag = featureFlags.find((f) => Object.is(f.key, key))
  return flag?.value === true
}
